import Employee from './Employee'
export class Batch {
    ID: number;
    CreatedDate: Date;
    EmployeeID: number;
    Employee: Employee;
    
}

export default Batch;